export const useText = (texts: any, key: string) => {
    return texts[key] ?? ''
}
